import ReactJS, { useRef, useEffect, useState, useMemo } from "react";
import Toolbar from "../../components/Toolbar";
import AxiosAPI from "../../scripts/AxiosAPI";
import {
  Badge,
  Flex,
  Image,
  Modal,
  notification,
  Popconfirm,
  Tabs,
} from "antd";

import { InboxOutlined, SearchOutlined } from "@ant-design/icons";
import type { InputRef, TableColumnsType, TableColumnType } from "antd";
import { Button, Input, Space, Table } from "antd";
import type { FilterDropdownProps } from "antd/es/table/interface";
import Highlighter from "react-highlight-words";
import DisableButtonRewardItem from "../../components/DisableButtonRewardItem";
import ExportCSVButton from "../../components/ExportCSVButton";
import type { UploadProps } from "antd";
import { message, Upload } from "antd";
import axios from "axios";

import FormData from "form-data";

interface DataType {
  key: string;
  thumbnail: string;
  name: string;
  points: any;
  price: any;
  action: any;
}

type DataIndex = keyof DataType;

function RewardsPrizesComponent() {
  const [itemLabel, setItemLabel] = useState("");

  const [selectedItem, setSelectedItem] = useState({
    id: 0,
    name: "",
    points: 0,
  });

  const [items, setItems] = useState([]);

  const [modalOpenCreate, setModalOpenCreate] = useState(false);

  const [modalOpenEdit, setModalOpenEdit] = useState(false);

  const [id, setId] = useState(0);

  const [name, setName] = useState("");

  const [points, setPoints] = useState(0);

  const [price, setPrice] = useState(0);

  const [thumbnail, setThumbnail] = useState("");

  const [enabled, setEnabled] = useState(false);

  const [api, contextHolder] = notification.useNotification();

  const addItem: any = () => {
    setModalOpenEdit(false);

    setModalOpenCreate(false);

    console.log("addItem", { id, name, points, thumbnail, price, enabled });

    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: "https://api-live.supplyzone.ai/super/reward-prizes/v1",
      headers: {},
      data: uploadFormData,
    };
    axios
      .request(config)
      .then((response) => {
        api.info({
          message: `Completed`,
          description: `${name} has been updated successfully!`,
          placement: `topRight`,
        });

        refreshListView();
        console.log("ITEM UPDATED", response.data, uploadFormData, {
          id,
          name,
          points,
          thumbnail,
          price,
          enabled,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const openNewItemModal: any = () => {
    setId(0);

    setName("");

    setThumbnail("");

    setPrice(0);

    setPoints(0);

    setEnabled(false);

    setModalOpenCreate(true);
  };

  const editItemFormImage: any = () => {
    let data = new FormData();
    data.append("id", id);
    data.append("name", name);
    data.append("points", points);
    data.append("price", price);
    fetch("https://api-live.supplyzone.ai/home/product-attachment/" + thumbnail)
      .then((response) => response.blob())
      .then((blob) => {
        // Do something with the blob data
        console.log(blob);
        data.append("image", blob, {
          filename: "image.jpg",
          contentType: blob.type,
        });
        setUploadFormData(data);
      });
  };

  const editItem: any = () => {

    setModalOpenEdit(false);

    setModalOpenCreate(false);

    console.log("editItem", { id, name, points, thumbnail, price, enabled });

    console.log("uploadFormData", uploadFormData);

    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: "https://api-live.supplyzone.ai/super/reward-prizes/v1",
      headers: {},
      data: uploadFormData,
    };
    axios
      .request(config)
      .then((response) => {
        api.info({
          message: `Completed`,
          description: `${name} has been updated successfully!`,
          placement: `topRight`,
        });

        refreshListView();
        console.log("ITEM UPDATED", response.data, {
          id,
          name,
          points,
          thumbnail,
          price,
          enabled,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const editItemV2: any = () => {
    setModalOpenEdit(false);

    setModalOpenCreate(false);

    console.log("editItem", { id, name, points, thumbnail, price, enabled });

    const payload: any = { id, name, points, thumbnail, price, enabled };

    AxiosAPI.setRewardsItems(name, points, price, thumbnail, id)
      .then((res: any) => {
        console.log(res.data);

        api.info({
          message: `Completed`,
          description: `${name} has been updated successfully!`,
          placement: `topRight`,
        });

        refreshListView();
      })
      .catch(() => {});
  };

  const editThisItem: any = (item: any) => {
    setSelectedItem(item);

    console.log("editThisItem::", item);

    setId(item.id);

    setName(item.name);

    setThumbnail(item.s3Key);

    setPrice(item.price);

    setPoints(item.points);

    setEnabled(item.enabled);

    setModalOpenEdit(true);

    console.log({ id, name, points, thumbnail, price, enabled });
  };

  useEffect(() => {
    setItemLabel("Rewards Reward Items");

    AxiosAPI.getRewardsEventTypes()
      .then((res: any) => {
        const _data = res.data;

        setItems(_data);
      })
      .catch((error: any) => {});
  }, []);

  useEffect(() => {
    setModalOpenCreate(false);
  }, [selectedItem]);

  const [eventTypesData, setEventTypesData] = useState([]);
  const [eventTypesDataDisabled, setEventTypesDataDisabled] = useState([]);
  const [exportData, setExportData] = useState([]);

  const refreshListView: any = () => {
    AxiosAPI.getRewardsItems()
      .then((res: any) => {
        let _eventTypes: any = res.data;
        setExportData(_eventTypes);
        const activeItems: any = _eventTypes.map(
          (item: any, itemIndex: number) => {
            if (item) {
              return {
                key: itemIndex,
                thumbnail: (
                  <>
                    <img
                      width="40"
                      src={`https://api-live.supplyzone.ai//home/product-attachment/${item.s3Key}`}
                      alt=""
                    />
                  </>
                ),
                name: item.name,
                points: item.points,
                price: item.price,
                action: (
                  <Flex gap={20}>
                    <Button
                      type="primary"
                      size="large"
                      onClick={() => editThisItem(item)}
                      className="m-r-5"
                    >
                      Edit Reward Item
                    </Button>
                    <DisableButtonRewardItem
                      onDeleteItem={refreshListView}
                      item={item}
                      disable={true}
                    />
                  </Flex>
                ),
              };
            }
          }
        );
        setEventTypesData(
          activeItems.filter((value: any) => value !== undefined)
        );

        console.log(
          "setEventTypesData",
          activeItems.filter((value: any) => value !== undefined)
        );
      })
      .catch((error: any) => {
        // Handle error
      });
  };

  useMemo(() => {
    refreshListView();
  }, []);

  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const searchInput = useRef<InputRef>(null);

  const handleSearch = (
    selectedKeys: string[],
    confirm: FilterDropdownProps["confirm"],
    dataIndex: DataIndex
  ) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  const handleReset = (clearFilters: () => void) => {
    clearFilters();
    setSearchText("");
  };

  const getColumnSearchProps = (
    dataIndex: DataIndex
  ): TableColumnType<DataType> => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
      close,
    }) => (
      <div style={{ padding: 8 }} onKeyDown={(e) => e.stopPropagation()}>
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() =>
            handleSearch(selectedKeys as string[], confirm, dataIndex)
          }
          style={{ marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() =>
              handleSearch(selectedKeys as string[], confirm, dataIndex)
            }
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              confirm({ closeDropdown: false });
              setSearchText((selectedKeys as string[])[0]);
              setSearchedColumn(dataIndex);
            }}
          >
            Filter
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              close();
            }}
          >
            close
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered: boolean) => (
      <SearchOutlined style={{ color: filtered ? "#1677ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        .toString()
        .toLowerCase()
        .includes((value as string).toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });

  const columns: TableColumnsType<DataType> = [
    {
      title: "Reward Image",
      dataIndex: "thumbnail",
      key: "thumbnail",
      width: "15%",
      ...getColumnSearchProps("thumbnail"),
    },
    {
      title: "Reward Name",
      dataIndex: "name",
      key: "name",
      ...getColumnSearchProps("name"),
    },
    {
      title: "Reward Points",
      dataIndex: "points",
      key: "points",
      width: "15%",
      ...getColumnSearchProps("points"),
    },
    {
      title: "Price Value",
      dataIndex: "price",
      key: "price",
      width: "15%",
      ...getColumnSearchProps("price"),
    },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      width: "20%",
    },
  ];

  const operations = <Button onClick={refreshListView}>Refresh Data</Button>;

  const [tabItems, setTabItems] = useState<any>([]);

  useEffect(() => {
    setTabItems([
      {
        label: (
          <>
            Reward Items{" "}
            <Badge count={eventTypesData.length} showZero color="#1c84ff" />
          </>
        ),
        key: 1,
        children: <Table columns={columns} dataSource={eventTypesData} />,
      },
    ]);
  }, [eventTypesData]);

  const { Dragger } = Upload;

  const [uploadFormData, setUploadFormData] = useState<any>();

  const props: UploadProps = {
    name: "file",
    multiple: false,
    showUploadList: false,
    action: "",
    onChange(info) {
      const { status } = info.file;
      if (status !== "uploading") {
        const itemFile: any = info.file.originFileObj;
        console.log(itemFile);
        let data = new FormData();
        data.append("id", id);
        data.append("name", name);
        data.append("points", points);
        data.append("price", price);
        data.append("image", itemFile);

        setUploadFormData(data);
      }
      //   if (status === "done") {
      //     message.success(`${info.file.name} file uploaded successfully.`);
      //   } else if (status === "error") {
      //     message.error(`${info.file.name} file upload failed.`);
      //   }
    },
    onDrop(e) {
      console.log("Dropped files", e.dataTransfer.files);
    },
  };

  return (
    <>
      {contextHolder}
      {/*begin::Toolbar*/}
      <div id="kt_app_toolbar" className="app-toolbar  py-3 py-lg-6 ">
        <Toolbar title={itemLabel}>
          {/*begin::Toolbar*/}
          <div
            className="d-flex justify-content-end"
            data-kt-user-table-toolbar="base"
            data-select2-id="select2-data-131-i76u"
          >
            <Flex gap={16}>
              {/*begin::Add user*/}
              <Button type="primary" size="large" onClick={openNewItemModal}>
                Add New
              </Button>
              {/*end::Add user*/}
              {/*begin::Export*/}
              <ExportCSVButton csvData={[...exportData]} />
              {/*end::Export*/}
            </Flex>
          </div>
          {/*end::Toolbar*/}
        </Toolbar>
      </div>
      {/*end::Toolbar*/}
      {/*begin::Content*/}
      <div
        id="kt_app_content"
        className="app-content  flex-column-fluid "
        data-select2-id="select2-data-kt_app_content"
      >
        {/*begin::Content container*/}
        <div
          id="kt_app_content_container"
          className="app-container  container-xxl "
          data-select2-id="select2-data-kt_app_content_container"
        >
          {/*begin::Card*/}
          <div className="card" data-select2-id="select2-data-134-i7jk">
            {/*begin::Card body*/}
            <div className="card-body py-4">
              {/*begin::Table*/}
              <div
                id="kt_table_users_wrapper"
                className="dt-container dt-bootstrap5 dt-empty-footer pt-5"
              >
                <Tabs tabBarExtraContent={operations} items={tabItems} />
              </div>
              {/*end::Table*/}
            </div>
            {/*end::Card body*/}
          </div>
          {/*end::Card*/}
        </div>
        {/*end::Content container*/}
      </div>
      {/*end::Content*/}

      <Modal
        title={`Add New Item`}
        centered
        open={modalOpenCreate}
        onOk={() => {
          addItem();
          setModalOpenCreate(false);
        }}
        onCancel={() => setModalOpenCreate(false)}
      >
        {/*begin::Scroll*/}
        <div
          className="d-flex flex-column scroll-y px-0 py-10"
          id="kt_modal_add_item_scroll"
          data-kt-scroll="true"
          data-kt-scroll-activate="true"
          data-kt-scroll-max-height="auto"
          data-kt-scroll-dependencies="#kt_modal_add_item_header"
          data-kt-scroll-wrappers="#kt_modal_add_item_scroll"
          data-kt-scroll-offset="300px"
          style={{ maxHeight: 901 }}
        >
          {/*begin::Input group*/}
          <div className="fv-row mb-7 fv-plugins-icon-container">
            {/*begin::Label*/}
            <label className="required fw-semibold fs-6 mb-2">
              Reward Item Title
            </label>
            {/*end::Label*/}
            {/*begin::Input*/}
            <input
              type="text"
              name="user_name"
              className="form-control form-control-solid mb-3 mb-lg-0"
              placeholder="The reward item title"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
            {/*end::Input*/}
            <div className="fv-plugins-message-container fv-plugins-message-container--enabled invalid-feedback"></div>
          </div>
          {/*end::Input group*/}
          {/*begin::Input group*/}
          <div className="fv-row mb-7 fv-plugins-icon-container">
            {/*begin::Label*/}
            <label className="required fw-semibold fs-6 mb-2">
              Reward Item Points
            </label>
            {/*end::Label*/}
            {/*begin::Input*/}
            <input
              type="number"
              className="form-control form-control-solid mb-3 mb-lg-0"
              placeholder="The reward item points"
              value={points}
              onChange={(e) => setPoints(Number(e.target.value))}
            />
            {/*end::Input*/}
            <div className="fv-plugins-message-container fv-plugins-message-container--enabled invalid-feedback"></div>
          </div>
          {/*end::Input group*/}
          {/*begin::Input group*/}
          <div className="fv-row mb-7 fv-plugins-icon-container">
            {/*begin::Label*/}
            <label className="required fw-semibold fs-6 mb-2">
              Reward Item Price
            </label>
            {/*end::Label*/}
            {/*begin::Input*/}
            <input
              type="number"
              className="form-control form-control-solid mb-3 mb-lg-0"
              placeholder="The reward item points"
              value={price}
              onChange={(e) => setPrice(Number(e.target.value))}
            />
            {/*end::Input*/}
            <div className="fv-plugins-message-container fv-plugins-message-container--enabled invalid-feedback"></div>
          </div>
          {/*end::Input group*/}
          {/*begin::Input group*/}
          <div className="fv-row mb-7 fv-plugins-icon-container mt-10">
            {/*begin::Label*/}
            <label className="required fw-semibold fs-6 mb-2">
              Reward Item Image Preview
            </label>
            {/*end::Label*/}
            {/*begin::Input*/}
            <br />
            <Image
              width={64}
              src={`https://api-live.supplyzone.ai//home/product-attachment/${thumbnail}`}
            />
            {/*end::Input*/}
            <div className="fv-plugins-message-container fv-plugins-message-container--enabled invalid-feedback"></div>
          </div>
          {/*end::Input group*/}
          <br />
          <Dragger {...props}>
            <p className="ant-upload-drag-icon">
              <InboxOutlined />
            </p>
            <p className="ant-upload-text">
              Click or drag file to this area to upload
            </p>
            <p className="ant-upload-hint">
              Support for a single or bulk upload. Strictly prohibited from
              uploading company data or other banned files.
            </p>
          </Dragger>
        </div>
        {/*end::Scroll*/}
      </Modal>

      <Modal
        title={`Edit ${name}`}
        centered
        open={modalOpenEdit}
        onOk={() => {
          editItem();
          setModalOpenEdit(false);
        }}
        onCancel={() => setModalOpenEdit(false)}
      >
        {/*begin::Scroll*/}
        <div
          className="d-flex flex-column scroll-y px-0 py-10"
          id="kt_modal_edit_item_scroll"
          data-kt-scroll="true"
          data-kt-scroll-activate="true"
          data-kt-scroll-max-height="auto"
          data-kt-scroll-dependencies="#kt_modal_add_item_header"
          data-kt-scroll-wrappers="#kt_modal_add_item_scroll"
          data-kt-scroll-offset="300px"
          style={{ maxHeight: 901 }}
        >
          {/*begin::Input group*/}
          <div className="fv-row mb-7 fv-plugins-icon-container">
            {/*begin::Label*/}
            <label className="required fw-semibold fs-6 mb-2">
              Reward Item Title
            </label>
            {/*end::Label*/}
            {/*begin::Input*/}
            <input
              type="text"
              name="user_name"
              className="form-control form-control-solid mb-3 mb-lg-0"
              placeholder="The reward item title"
              value={name}
              onChange={(e) => {
                setName(e.target.value);
                editItemFormImage();
              }}
            />
            {/*end::Input*/}
            <div className="fv-plugins-message-container fv-plugins-message-container--enabled invalid-feedback"></div>
          </div>
          {/*end::Input group*/}
          {/*begin::Input group*/}
          <div className="fv-row mb-7 fv-plugins-icon-container">
            {/*begin::Label*/}
            <label className="required fw-semibold fs-6 mb-2">
              Reward Item Points
            </label>
            {/*end::Label*/}
            {/*begin::Input*/}
            <input
              type="number"
              className="form-control form-control-solid mb-3 mb-lg-0"
              placeholder="The reward item points"
              value={points}
              onChange={(e) => {
                setPoints(Number(e.target.value));
                editItemFormImage();
              }}
            />
            {/*end::Input*/}
            <div className="fv-plugins-message-container fv-plugins-message-container--enabled invalid-feedback"></div>
          </div>
          {/*end::Input group*/}
          {/*begin::Input group*/}
          <div className="fv-row mb-7 fv-plugins-icon-container">
            {/*begin::Label*/}
            <label className="required fw-semibold fs-6 mb-2">
              Reward Item Price
            </label>
            {/*end::Label*/}
            {/*begin::Input*/}
            <input
              type="number"
              className="form-control form-control-solid mb-3 mb-lg-0"
              placeholder="The reward item points"
              value={price}
              onChange={(e) => {
                setPrice(Number(e.target.value));
                editItemFormImage();
              }}
            />
            {/*end::Input*/}
            {/*begin::Input group*/}
            <div className="fv-row mb-7 fv-plugins-icon-container mt-10">
              {/*begin::Label*/}
              <label className="required fw-semibold fs-6 mb-2">
                Reward Item Image Preview
              </label>
              {/*end::Label*/}
              {/*begin::Input*/}
              <br />
              <Image
                width={64}
                src={`https://api-live.supplyzone.ai//home/product-attachment/${thumbnail}`}
              />
              {/*end::Input*/}
              <div className="fv-plugins-message-container fv-plugins-message-container--enabled invalid-feedback"></div>
            </div>
            {/*end::Input group*/}
            <div className="fv-plugins-message-container fv-plugins-message-container--enabled invalid-feedback"></div>
          </div>
          {/*end::Input group*/}
          <Dragger {...props}>
            <p className="ant-upload-drag-icon">
              <InboxOutlined />
            </p>
            <p className="ant-upload-text">
              Click or drag file to this area to upload
            </p>
            <p className="ant-upload-hint">
              Support for a single or bulk upload. Strictly prohibited from
              uploading company data or other banned files.
            </p>
          </Dragger>
        </div>
        {/*end::Scroll*/}
      </Modal>
    </>
  );
}

export default RewardsPrizesComponent;
